module.exports = __webpack_public_path__ + "assets/img/edit.d817c71f.svg";